import styled from 'styled-components';

export const Wrapper = styled.div`
	margin-top: 24px;
	margin-bottom: 64px;
	background-color: ${({ theme }) => theme.colors.background.secondary};
	border-radius: 0 0 9px 9px;
`;

export const TableWrapper = styled.div`
	@media (max-width: 992px) {
		overflow-x: auto;
		width: 100%;
	}
`;

export const Table = styled.table`
	width: 100%;
	border: none;
	outline: none;
	border-collapse: separate;
	border-spacing: 0;

	thead tr:first-child th:first-child {
		border-top-left-radius: 9px;
		border: 1px solid ${({ theme }) => theme.colors.transparent.light10};
		border-right: none;
	}

	thead tr:first-child th:last-child {
		border-top-right-radius: 9px;
		border: 1px solid ${({ theme }) => theme.colors.transparent.light10};
		border-left: none;
	}

	thead tr:first-child th:nth-child(2) {
		border: 1px solid ${({ theme }) => theme.colors.transparent.light10};
		border-left: none;
		border-right: none;
	}

	thead tr:first-child th:nth-child(3) {
		border: 1px solid ${({ theme }) => theme.colors.transparent.light10};
		border-left: none;
		border-right: none;
	}

	tbody tr:last-child td:first-child {
		border-bottom-left-radius: 9px;
	}

	tbody tr:last-child td:last-child {
		border-bottom-right-radius: 9px;
	}
`;

export const Head = styled.tr`
	font-size: 16px;
	font-weight: 600;
	background-color: ${({ theme }) => theme.colors.background.main};
	color: ${({ theme }) => theme.colors.text.subtitle};
	height: 60px;
`;

export const HeadItem = styled.th`
	padding: 16px 20px;
	text-align: left;
	font-weight: 500;
`;

export const Body = styled.tbody`
	background-color: ${({ theme }) => theme.colors.background.secondary};
	border-top: none;

	td {
		border: none;
	}
`;

export const BodyItem = styled.tr`
	font-size: 14px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	border: none;

	&:last-child {
		border-bottom: none;
	}

	td {
		padding: 10px 20px;
	}
`;

export const BodyItemName = styled.td`
	text-align: left;
	border: none;
`;

export const PaginationWrapper = styled.div`
	display: flex;
	justify-content: flex-end;
	margin-top: 16px;
`;
